<template>
  <div id="trs-main" class="page-agreement">
    <div class="container-agreement">
        <div class="box panel-agreement">
          <div class="box-ct">
            <div class="alert alert-danger" v-if="errorMessage != null">{{ $t(errorMessage) }}</div>
            <div v-if="newsInfo.hasAgreementFxBlock">
          <div style="margin-bottom: 2%">
            <img style="height: 33px" src="@/assets/img/trslogo.png">
          </div>
          <div class="box-intro" v-html="$t('label.agreement.fx.fxIntro')"></div>
          <div class="section">
            <h2 class="section-title">{{ $t('label.agreement.regulationFX_BO_CryptoFX') }}</h2>
            <div class="section-ct">
              <div class="section-box">
                <div class="box-item">
                  <div class="left-part">
                    <div class="section-box-item">
                      <ul class="list-unstyled">
                        <li>
                          <a :href="this.minStHome+'pdf/regulation_fxattention.pdf'" target="_blank">
                            <i class="far fa-file-pdf"></i> {{ $t('label.agreement.fx.regulationFxattention') }}
                          </a>
                        </li>
                        <li>
                          <a :href="this.minStHome+'pdf/regulation_overview.pdf'" target="_blank">
                            <i class="far fa-file-pdf"></i> {{ $t('label.agreement.fx.regulationOverview') }}
                          </a>
                        </li>
                        <li>
                          <a :href="this.minStHome+'pdf/regulation_rules.pdf'" target="_blank">
                            <i class="far fa-file-pdf"></i> {{ $t('label.agreement.fx.regulationRules') }}
                          </a>
                        </li>
                      </ul>
                      <hr />
                      <ul class="list-unstyled">
                        <li>
                          <a :href="this.minStHome+'pdf/regulation_keiyakumaekofu.pdf'" target="_blank">
                            <i class="far fa-file-pdf"></i> {{ $t('label.agreement.fx.regulationKeiyakumaekofu') }}
                          </a>
                        </li>
                        <li>
                          <a :href="this.minStHome+'pdf/regulation_komonkeiyaku.pdf'"  target="_blank" >
                            <i class="far fa-file-pdf" ></i> {{ $t('label.agreement.fx.regulationKomonkeiyaku') }}
                          </a>
                        </li>
                      </ul>
                      <hr />
                      <ul class="list-unstyled">
                        <li>
                          <a :href="this.minStHome+'pdf/regulation_trader_agreement.pdf'"  target="_blank">
                            <i class="far fa-file-pdf"></i> {{ $t('label.agreement.fx.regulationTraderAgreement') }}
                          </a>
                        </li>
                      </ul>
                      <hr />
                      <ul class="list-unstyled">
                        <li>
                          <a :href="this.minStHome+'pdf/regulation_hansya.pdf'"  target="_blank">
                            <i class="far fa-file-pdf"></i> {{ $t('label.agreement.fx.regulationHansya') }}
                          </a>
                        </li>
                        <li>
                          <a :href="this.minStHome+'pdf/tsc_privacy.pdf'"  target="_blank">
                            <i class="far fa-file-pdf"></i> {{ $t('label.agreement.fx.tscPrivacy') }}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="right-part background-block" :class="cssDivYes(fxBlock.checkbox1)" @click.self="toggleCheckbox($event)">
                    <div>
                         <label class="label-checkbox" :class="cssLabelYes(fxBlock.checkbox1)">
                             <input class="checkboxone" type="checkbox" v-model="$v.fxBlock.checkbox1.$model" :true-value=YES :false-value=UN_YES
                                    @click.self="selectQuestion('fxBlock', 'checkbox1', YES, $event)"/>
                             <span class="checkbox_agree">{{ $t('customer.agree.accept') }}</span>
                         </label>
                    </div>
                      <div class="error-messages-block-custom error-messages-block-custom2 top--12px">
                        <error-messages-block :className="'error-messages-agreement ng-active left1'" :field="$v.fxBlock.checkbox1">
                            <template #required>{{ $t('accept.news.error.required') }}</template>
                        </error-messages-block>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="section">
            <h2 class="section-title">{{ $t('label.agreement.fx.transactions')}}</h2>
            <div class="section-ct">
              <div class="section-box">
                <div class="box-item">
                  <div class="left-part">
                    <div class="section-box-item" v-html="$t('label.agreement.fx.transactionContent')"></div>
                  </div>
                  <div class="right-part background-block" :class="cssDivYes(fxBlock.checkbox2)" @click.self="toggleCheckbox($event)">
                    <div>
                        <label class="label-checkbox" :class="cssLabelYes(fxBlock.checkbox2)">
                            <input class="checkboxone" type="checkbox" v-model="$v.fxBlock.checkbox2.$model" :true-value=YES :false-value=UN_YES
                                   @click.self="selectQuestion('fxBlock', 'checkbox2', YES, $event)"/>
                            <span class="checkbox_agree">{{ $t('customer.agree.accept') }}</span>
                        </label>
                    </div>
                      <div class="error-messages-block-custom error-messages-block-custom2 top--12px">
                        <error-messages-block :className="'error-messages-agreement ng-active left1'" :field="$v.fxBlock.checkbox2">
                            <template #required>{{ $t('accept.news.error.required') }}</template>
                        </error-messages-block>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="section">
            <h2 class="section-title">{{ $t('label.agreement.fx.confirmTitle') }}</h2>
            <div class="section-ct">
              <div class="section-box">
                <div class="box-item">
                  <div class="left-part">
                    <div class="section-box-item">
                      <p>
                        {{ $t('label.agreement.fx.confirmContent1') }}
                        <br>
                        <a href="" @click.prevent="showLendModal">{{ $t('label.agreement.fx.loanBorrowAccount') }}</a>
                      </p>
                      <hr>
                      <p>
                        {{ $t('label.agreement.fx.confirmContent2') }}<a href="" @click.prevent="showPepModal">{{ $t('label.agreement.fx.foreignPEPs') }}</a>{{ $t('label.agreement.fx.applyNoteFX1') }}<br>
                        {{ $t('label.agreement.fx.applyNoteFX2') }}<br>
                        {{ $t('label.agreement.fx.applyNoteFX3') }}<br>
                        <a :href="this.minStHome+'pdf/regulation_crs.pdf'" target ="_blank"><i class="far fa-file-pdf"></i> {{ $t('label.agreement.fx.regulationCrs') }}</a>
                      </p>
                      <hr>
                      <p v-if="newsInfo.resultAgreeNews.corporationType == 1">
                        {{ $t('label.agreement.fx.confirmContent3') }}
                      </p>
                    </div>
                  </div>
                  <div class="right-part background-block" :class="cssDivYes(fxBlock.checkbox3)" @click.self="toggleCheckbox($event)">
                     <div class="checkbox-block">
                         <div class="checkbox-custom vertical-line-fx">
                             <label class="label-checkbox" :class="cssLabelYes(fxBlock.checkbox3)">
                                 <input class="checkboxone" type="checkbox" v-model="$v.fxBlock.checkbox3.$model" :true-value=YES :false-value=UN_YES
                                        @click.self="selectQuestion('fxBlock', 'checkbox3', YES, $event)"/>
                                 <span class="checkbox_agree">{{ $t('customer.agree.yes') }}</span>
                             </label>
                         </div>
                         <div class="checkbox-custom">
                             <label class="label-checkbox" :class="cssLabelNo(fxBlock.checkbox3)">
                                 <input class="checkboxone" type="checkbox" v-model="$v.fxBlock.checkbox3.$model" :true-value=NO :false-value=UN_NO
                                        @click.self="selectQuestion('fxBlock', 'checkbox3', NO, $event)"/>
                                 <span class="checkbox_agree">{{ $t('customer.agree.no') }}</span>
                             </label>
                         </div>
                     </div>
                      <div class="error-messages-block-custom error-messages-block-custom3 top--126px">
                          <error-messages-block :className="'error-messages-agreement ng-active'" :field="$v.fxBlock.checkbox3">
                              <template #required>{{ $t('accept.news.error.required') }}</template>
                          </error-messages-block>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
            <!--BO block-->
            <div v-if="newsInfo.hasAgreementBoBlock">
          <div style="margin-bottom: 2%">
            <img style="height: 33px" src="@/assets/img/bo-block-logo.svg">
          </div>
          <div class="box-intro" v-html="$t('label.agreement.bo.boIntro')"></div>
          <div class="section" >
            <h2 class="section-title">{{ $t('label.agreement.regulationFX_BO_CryptoFX') }}</h2>
            <div class="section-ct">
              <div class="section-box">
                <div class="box-item">
                  <div class="left-part">
                    <div class="section-box-item">
                      <ul class="list-unstyled">
                        <li><a :href="this.minStHome+'pdf/regulation_boattention.pdf'" target="_blank"><i class="far fa-file-pdf"></i> {{ $t('label.agreement.bo.regulationBoattention') }}</a></li>
                        <li><a :href="this.minStHome+'pdf/regulation_overview_op.pdf' " target="_blank"><i class="far fa-file-pdf"></i> {{ $t('label.agreement.bo.regulationOverviewOp') }}</a></li>
                        <li><a :href="this.minStHome+'pdf/regulation_rules_op.pdf'" target="_blank"><i class="far fa-file-pdf"></i> {{ $t('label.agreement.bo.regulationRulesOp') }}</a></li>
                      </ul>
                    </div>
                  </div>
                  <div class="right-part background-block" :class="cssDivYes(boBlock.checkbox1)" @click.self="toggleCheckbox($event)">
                     <div>
                          <label class="label-checkbox" :class="cssLabelYes(boBlock.checkbox1)">
                              <input class="checkboxone" type="checkbox" v-model="$v.boBlock.checkbox1.$model" :true-value=YES :false-value=UN_YES
                                     @click.self="selectQuestion('boBlock', 'checkbox1', YES, $event)"/>
                              <span class="checkbox_agree">{{ $t('customer.agree.accept') }}</span>
                          </label>
                     </div>
                      <div class="error-messages-block-custom error-messages-block-custom2 top--12px">
                         <error-messages-block :className="'error-messages-agreement ng-active left1'" :field="$v.boBlock.checkbox1">
                             <template #required>{{ $t('accept.news.error.required') }}</template>
                         </error-messages-block>
                     </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="section">
            <h2 class="section-title">{{ $t('label.agreement.bo.confirmOptionTrading') }}</h2>
            <div class="section-ct section-ct-group">
              <div class="section-box">
                <div class="box-item">
                  <div class="left-part">
                    <div class="section-box-item">
                      <p>{{ $t('label.agreement.bo.confirmContent1') }}</p>
                    </div>
                  </div>
                  <div class="right-part background-block" :class="cssDivYes(boBlock.checkbox2)" @click.self="toggleCheckbox($event)">
                      <div class="checkbox-block2 h-82px">
                          <div class="checkbox-custom vertical-line-bo">
                              <label class="label-checkbox" :class="cssLabelYes(boBlock.checkbox2)">
                                  <input class="checkboxone" type="checkbox" v-model="$v.boBlock.checkbox2.$model" :true-value=YES :false-value=UN_YES
                                         @click.self="selectQuestion('boBlock', 'checkbox2', YES, $event)"/>
                                  <span class="checkbox_agree">{{ $t('customer.agree.yes') }}</span>
                              </label>
                          </div>
                          <div class="checkbox-custom">
                              <label class="label-checkbox" :class="cssLabelNo(boBlock.checkbox2)">
                                  <input class="checkboxone" type="checkbox" v-model="$v.boBlock.checkbox2.$model" :true-value=NO :false-value=UN_NO
                                         @click.self="selectQuestion('boBlock', 'checkbox2', NO, $event)"/>
                                  <span class="checkbox_agree">{{ $t('customer.agree.no') }}</span>
                              </label>
                          </div>
                      </div>
                      <div class="error-messages-block-custom top--16px">
                          <error-messages-block :className="'error-messages-agreement ng-active'" :field="$v.boBlock.checkbox2">
                              <template #required>{{ $t('accept.news.error.required') }}</template>
                          </error-messages-block>
                      </div>
                  </div>
                </div>
              </div>
              <div class="section-box">
                <div class="box-item">
                  <div class="left-part">
                    <div class="section-box-item">
                      <p v-html="$t('label.agreement.bo.confirmContent2')"></p>
                    </div>
                  </div>
                  <div class="right-part background-block" :class="cssDivYes(boBlock.checkbox3)" @click.self="toggleCheckbox($event)">
                      <div class="checkbox-block2 h-100px">
                          <div class="checkbox-custom vertical-line-bo">
                              <label class="label-checkbox" :class="cssLabelYes(boBlock.checkbox3)">
                                  <input class="checkboxone" type="checkbox" v-model="$v.boBlock.checkbox3.$model" :true-value=YES :false-value=UN_YES
                                         @click.self="selectQuestion('boBlock', 'checkbox3', YES, $event)"/>
                                  <span class="checkbox_agree">{{ $t('customer.agree.yes') }}</span>
                              </label>
                          </div>
                          <div class="checkbox-custom">
                              <label class="label-checkbox" :class="cssLabelNo(boBlock.checkbox3)">
                                  <input class="checkboxone" type="checkbox" v-model="$v.boBlock.checkbox3.$model" :true-value=NO :false-value=UN_NO
                                         @click.self="selectQuestion('boBlock', 'checkbox3', NO, $event)"/>
                                  <span class="checkbox_agree">{{ $t('customer.agree.no') }}</span>
                              </label>
                          </div>
                      </div>
                      <div class="error-messages-block-custom top--24px">
                          <error-messages-block :className="'error-messages-agreement ng-active'" :field="$v.boBlock.checkbox3">
                              <template #required>{{ $t('accept.news.error.required') }}</template>
                          </error-messages-block>
                      </div>
                  </div>
                </div>
              </div>
              <div class="section-box">
                <div class="box-item">
                  <div class="left-part">
                    <div class="section-box-item">
                      <p v-html="$t('label.agreement.bo.confirmContent3')"></p>
                    </div>
                  </div>
                  <div class="right-part background-block" :class="cssDivYes(boBlock.checkbox4)" @click.self="toggleCheckbox($event)">
                      <div class="checkbox-block2 h-82px">
                          <div class="checkbox-custom vertical-line-bo">
                              <label class="label-checkbox" :class="cssLabelYes(boBlock.checkbox4)">
                                  <input class="checkboxone" type="checkbox" v-model="$v.boBlock.checkbox4.$model" :true-value=YES :false-value=UN_YES
                                         @click.self="selectQuestion('boBlock', 'checkbox4', YES, $event)"/>
                                  <span class="checkbox_agree">{{ $t('customer.agree.yes') }}</span>
                              </label>
                          </div>
                          <div class="checkbox-custom">
                              <label class="label-checkbox" :class="cssLabelNo(boBlock.checkbox4)">
                                  <input class="checkboxone" type="checkbox" v-model="$v.boBlock.checkbox4.$model" :true-value=NO :false-value=UN_NO
                                         @click.self="selectQuestion('boBlock', 'checkbox4', NO, $event)"/>
                                  <span class="checkbox_agree">{{ $t('customer.agree.no') }}</span>
                              </label>
                          </div>
                      </div>
                      <div class="error-messages-block-custom top--16px">
                          <error-messages-block :className="'error-messages-agreement ng-active'" :field="$v.boBlock.checkbox4">
                              <template #required>{{ $t('accept.news.error.required') }}</template>
                          </error-messages-block>
                      </div>
                  </div>
                </div>
              </div>
              <div class="section-box">
                <div class="box-item">
                  <div class="left-part">
                    <div class="section-box-item">
                      <p v-html="$t('label.agreement.bo.confirmContent4')"></p>
                    </div>
                  </div>
                  <div class="right-part background-block" :class="cssDivYes(boBlock.checkbox5)" @click.self="toggleCheckbox($event)">
                      <div class="checkbox-block2 h-82px">
                          <div class="checkbox-custom vertical-line-bo">
                              <label class="label-checkbox" :class="cssLabelYes(boBlock.checkbox5)">
                                  <input class="checkboxone" type="checkbox" v-model="$v.boBlock.checkbox5.$model" :true-value=YES :false-value=UN_YES
                                         @click.self="selectQuestion('boBlock', 'checkbox5', YES, $event)"/>
                                  <span class="checkbox_agree">{{ $t('customer.agree.yes') }}</span>
                              </label>
                          </div>
                          <div class="checkbox-custom">
                              <label class="label-checkbox" :class="cssLabelNo(boBlock.checkbox5)">
                                  <input class="checkboxone" type="checkbox" v-model="$v.boBlock.checkbox5.$model" :true-value=NO :false-value=UN_NO
                                         @click.self="selectQuestion('boBlock', 'checkbox5', NO, $event)"/>
                                  <span class="checkbox_agree">{{ $t('customer.agree.no') }}</span>
                              </label>
                          </div>
                      </div>
                      <div class="error-messages-block-custom top--16px">
                          <error-messages-block :className="'error-messages-agreement ng-active'" :field="$v.boBlock.checkbox5">
                              <template #required>{{ $t('accept.news.error.required') }}</template>
                          </error-messages-block>
                      </div>
                  </div>
                </div>
              </div>
              <div class="section-box">
                <div class="box-item">
                  <div class="left-part">
                    <div class="section-box-item">
                      <p v-html="$t('label.agreement.bo.confirmContent5')"></p>
                    </div>
                  </div>
                  <div class="right-part background-block" :class="cssDivYes(boBlock.checkbox6)" @click.self="toggleCheckbox($event)">
                      <div class="checkbox-block2 h-100px">
                          <div class="checkbox-custom vertical-line-bo">
                              <label class="label-checkbox" :class="cssLabelYes(boBlock.checkbox6)">
                                  <input class="checkboxone" type="checkbox" v-model="$v.boBlock.checkbox6.$model" :true-value=YES :false-value=UN_YES
                                         @click.self="selectQuestion('boBlock', 'checkbox6', YES, $event)"/>
                                  <span class="checkbox_agree">{{ $t('customer.agree.yes') }}</span>
                              </label>
                          </div>
                          <div class="checkbox-custom">
                              <label class="label-checkbox" :class="cssLabelNo(boBlock.checkbox6)">
                                  <input class="checkboxone" type="checkbox" v-model="$v.boBlock.checkbox6.$model" :true-value=NO :false-value=UN_NO
                                         @click.self="selectQuestion('boBlock', 'checkbox6', NO, $event)"/>
                                  <span class="checkbox_agree">{{ $t('customer.agree.no') }}</span>
                              </label>
                          </div>
                      </div>
                      <div class="error-messages-block-custom top--24px">
                          <error-messages-block :className="'error-messages-agreement ng-active'" :field="$v.boBlock.checkbox6">
                              <template #required>{{ $t('accept.news.error.required') }}</template>
                          </error-messages-block>
                      </div>
                  </div>
                </div>
              </div>
              <div class="section-box">
                <div class="box-item">
                  <div class="left-part">
                    <div class="section-box-item">
                      <p v-html="$t('label.agreement.bo.confirmContent6')"></p>
                    </div>
                  </div>
                  <div class="right-part background-block" :class="cssDivYes(boBlock.checkbox7)" @click.self="toggleCheckbox($event)">
                      <div class="checkbox-block2 h-82px">
                          <div class="checkbox-custom vertical-line-bo">
                              <label class="label-checkbox" :class="cssLabelYes(boBlock.checkbox7)">
                                  <input class="checkboxone" type="checkbox" v-model="$v.boBlock.checkbox7.$model" :true-value=YES :false-value=UN_YES
                                         @click.self="selectQuestion('boBlock', 'checkbox7', YES, $event)"/>
                                  <span class="checkbox_agree">{{ $t('customer.agree.yes') }}</span>
                              </label>
                          </div>
                          <div class="checkbox-custom">
                              <label class="label-checkbox" :class="cssLabelNo(boBlock.checkbox7)">
                                  <input class="checkboxone" type="checkbox" v-model="$v.boBlock.checkbox7.$model" :true-value=NO :false-value=UN_NO
                                         @click.self="selectQuestion('boBlock', 'checkbox7', NO, $event)"/>
                                  <span class="checkbox_agree">{{ $t('customer.agree.no') }}</span>
                              </label>
                          </div>
                      </div>
                      <div class="error-messages-block-custom top--16px">
                          <error-messages-block :className="'error-messages-agreement ng-active'" :field="$v.boBlock.checkbox7">
                              <template #required>{{ $t('accept.news.error.required') }}</template>
                          </error-messages-block>
                      </div>
                  </div>
                </div>
              </div>
              <div class="section-box">
                <div class="box-item">
                  <div class="left-part">
                    <div class="section-box-item">
                      <p v-html="$t('label.agreement.bo.confirmContent7')"></p>
                    </div>
                  </div>
                  <div class="right-part background-block" :class="cssDivYes(boBlock.checkbox8)" @click.self="toggleCheckbox($event)">
                      <div class="checkbox-block2 h-82px">
                          <div class="checkbox-custom vertical-line-bo">
                              <label class="label-checkbox" :class="cssLabelYes(boBlock.checkbox8)">
                                  <input class="checkboxone" type="checkbox" v-model="$v.boBlock.checkbox8.$model" :true-value=YES :false-value=UN_YES
                                         @click.self="selectQuestion('boBlock', 'checkbox8', YES, $event)"/>
                                  <span class="checkbox_agree">{{ $t('customer.agree.yes') }}</span>
                              </label>
                          </div>
                          <div class="checkbox-custom">
                              <label class="label-checkbox" :class="cssLabelNo(boBlock.checkbox8)">
                                  <input class="checkboxone" type="checkbox" v-model="$v.boBlock.checkbox8.$model" :true-value=NO :false-value=UN_NO
                                         @click.self="selectQuestion('boBlock', 'checkbox8', NO, $event)"/>
                                  <span class="checkbox_agree">{{ $t('customer.agree.no') }}</span>
                              </label>
                          </div>
                      </div>
                      <div class="error-messages-block-custom top--16px">
                          <error-messages-block :className="'error-messages-agreement ng-active'" :field="$v.boBlock.checkbox8">
                              <template #required>{{ $t('accept.news.error.required') }}</template>
                          </error-messages-block>
                      </div>
                  </div>
                </div>
              </div>
              <div class="section-box">
                <div class="box-item">
                  <div class="left-part">
                    <div class="section-box-item">
                      <p>{{ $t('label.agreement.bo.confirmContent8') }}</p>
                    </div>
                  </div>
                  <div class="right-part background-block" :class="cssDivYes(boBlock.checkbox9)" @click.self="toggleCheckbox($event)">
                      <div class="checkbox-block2 h-82px">
                          <div class="checkbox-custom vertical-line-bo">
                              <label class="label-checkbox" :class="cssLabelYes(boBlock.checkbox9)">
                                  <input class="checkboxone" type="checkbox" v-model="$v.boBlock.checkbox9.$model" :true-value=YES :false-value=UN_YES
                                         @click.self="selectQuestion('boBlock', 'checkbox9', YES, $event)"/>
                                  <span class="checkbox_agree">{{ $t('customer.agree.yes') }}</span>
                              </label>
                          </div>
                          <div class="checkbox-custom">
                              <label class="label-checkbox" :class="cssLabelNo(boBlock.checkbox9)">
                                  <input class="checkboxone" type="checkbox" v-model="$v.boBlock.checkbox9.$model" :true-value=NO :false-value=UN_NO
                                         @click.self="selectQuestion('boBlock', 'checkbox9', NO, $event)"/>
                                  <span class="checkbox_agree">{{ $t('customer.agree.no') }}</span>
                              </label>
                          </div>
                      </div>
                      <div class="error-messages-block-custom top--16px">
                          <error-messages-block :className="'error-messages-agreement ng-active'" :field="$v.boBlock.checkbox9">
                              <template #required>{{ $t('accept.news.error.required') }}</template>
                          </error-messages-block>
                      </div>
                  </div>
                </div>
              </div>
              <div class="section-box">
                <div class="box-item">
                  <div class="left-part">
                    <div class="section-box-item">
                      <p>{{ $t('label.agreement.bo.confirmContent9') }}</p>
                    </div>
                  </div>
                  <div class="right-part background-block" :class="cssDivYes(boBlock.checkbox10)" @click.self="toggleCheckbox($event)">
                      <div class="checkbox-block2 h-82px">
                          <div class="checkbox-custom vertical-line-bo">
                              <label class="label-checkbox" :class="cssLabelYes(boBlock.checkbox10)">
                                  <input class="checkboxone" type="checkbox" v-model="$v.boBlock.checkbox10.$model" :true-value=YES :false-value=UN_YES
                                         @click.self="selectQuestion('boBlock', 'checkbox10', YES, $event)"/>
                                  <span class="checkbox_agree">{{ $t('customer.agree.yes') }}</span>
                              </label>
                          </div>
                          <div class="checkbox-custom">
                              <label class="label-checkbox" :class="cssLabelNo(boBlock.checkbox10)">
                                  <input class="checkboxone" type="checkbox" v-model="$v.boBlock.checkbox10.$model" :true-value=NO :false-value=UN_NO
                                         @click.self="selectQuestion('boBlock', 'checkbox10', NO, $event)"/>
                                  <span class="checkbox_agree">{{ $t('customer.agree.no') }}</span>
                              </label>
                          </div>
                      </div>
                      <div class="error-messages-block-custom top--16px">
                          <error-messages-block :className="'error-messages-agreement ng-active'" :field="$v.boBlock.checkbox10">
                              <template #required>{{ $t('accept.news.error.required') }}</template>
                          </error-messages-block>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--CRYPTO-->
        <div v-if="newsInfo.hasAgreementCryptoFxBlock">
          <div style="margin-bottom: 2%">
            <!--<h1>CRYPTO</h1>-->
            <div style="margin-bottom: 2%">
                <img style="height: 35px" :src="cryptoLogo">
            </div>
          </div>
          <div class="box-intro" v-html="$t('label.agreement.cryptoFX.cryptoFXIntro')"></div>
          <div class="section" >
          <h2 class="section-title">{{ $t('label.agreement.cryptoFX.regulationCryptoFX') }}</h2>
          <div class="section-ct">
            <div class="section-box">
              <div class="box-item">
                <div class="left-part">
                  <div class="section-box-item">
                    <ul class="list-unstyled">
                      <li>
                        <a :href="this.minStHome+'pdf/regulation_attention_coin.pdf'" target="_blank">
                          <i class="far fa-file-pdf"></i> {{ $t('label.agreement.cryptoFX.regulationAttentionCoin') }}
                        </a>
                      </li>
                      <li>
                        <a :href="this.minStHome+'pdf/regulation_overview_coin.pdf'" target="_blank">
                          <i class="far fa-file-pdf"></i> {{ $t('label.agreement.cryptoFX.regulationOverviewCoin') }}
                        </a>
                      </li>
                      <li>
                        <a :href="this.minStHome+'pdf/regulation_rules_coin.pdf'" target="_blank">
                          <i class="far fa-file-pdf"></i> {{ $t('label.agreement.cryptoFX.regulationRulesCoin') }}
                        </a>
                      </li>
                      <li>
                        <a :href="this.minStHome+'pdf/regulation_insider_coin.pdf'" target="_blank">
                          <i class="far fa-file-pdf"></i> {{ $t('label.agreement.cryptoFX.regulationInsiderCoin') }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="right-part background-block" :class="cssDivYes(cryptoBlock.checkbox1)" @click.self="toggleCheckbox($event)">
                    <div>
                       <label class="label-checkbox" :class="cssLabelYes(cryptoBlock.checkbox1)">
                           <input class="checkboxone" type="checkbox" v-model="$v.cryptoBlock.checkbox1.$model" :true-value=YES :false-value=UN_YES
                                  @click.self="selectQuestion('cryptoBlock', 'checkbox1', YES, $event)"/>
                           <span class="checkbox_agree">{{ $t('customer.agree.accept') }}</span>
                       </label>
                    </div>
                    <div class="error-messages-block-custom error-messages-block-custom2 top--12px">
                        <error-messages-block :className="'error-messages-agreement ng-active left1'" :field="$v.cryptoBlock.checkbox1">
                            <template #required>{{ $t('accept.news.error.required') }}</template>
                        </error-messages-block>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
          <div class="section">
          <h2 class="section-title">{{ $t('label.agreement.cryptoFX.coinTrading') }}</h2>
          <div class="section-ct section-ct-group">
            <div class="section-box">
              <div class="box-item">
                <div class="left-part">
                  <div class="section-box-item">
                    <p>{{ $t('label.agreement.cryptoFX.confirmContent1') }}</p>
                  </div>
                </div>
                <div class="right-part background-block" :class="cssDivYes(cryptoBlock.checkbox2)" @click.self="toggleCheckbox($event)">
                    <div class="checkbox-block2 h-82px">
                        <div class="checkbox-custom vertical-line-crypto">
                            <label class="label-checkbox" :class="cssLabelYes(cryptoBlock.checkbox2)">
                                <input class="checkboxone" type="checkbox" v-model="$v.cryptoBlock.checkbox2.$model" :true-value=YES :false-value=UN_YES
                                       @click.self="selectQuestion('cryptoBlock', 'checkbox2', YES, $event)"/>
                                <span class="checkbox_agree">{{ $t('customer.agree.yes') }}</span>
                            </label>
                        </div>
                        <div class="checkbox-custom">
                            <label class="label-checkbox" :class="cssLabelNo(cryptoBlock.checkbox2)">
                                <input class="checkboxone" type="checkbox" v-model="$v.cryptoBlock.checkbox2.$model" :true-value=NO :false-value=UN_NO
                                       @click.self="selectQuestion('cryptoBlock', 'checkbox2', NO, $event)"/>
                                <span class="checkbox_agree">{{ $t('customer.agree.no') }}</span>
                            </label>
                        </div>
                    </div>
                    <div class="error-messages-block-custom top--16px">
                        <error-messages-block :className="'error-messages-agreement ng-active'" :field="$v.cryptoBlock.checkbox2">
                            <template #required>{{ $t('accept.news.error.required') }}</template>
                        </error-messages-block>
                    </div>
                </div>
              </div>
            </div>
            <div class="section-box">
              <div class="box-item">
                <div class="left-part">
                  <div class="section-box-item">
                    <p>{{ $t('label.agreement.cryptoFX.confirmContent2') }}</p>
                  </div>
                </div>
                <div class="right-part background-block" :class="cssDivYes(cryptoBlock.checkbox3)" @click.self="toggleCheckbox($event)">
                    <div class="checkbox-block2 h-82px">
                        <div class="checkbox-custom vertical-line-crypto">
                            <label class="label-checkbox" :class="cssLabelYes(cryptoBlock.checkbox3)">
                                <input class="checkboxone" type="checkbox" v-model="$v.cryptoBlock.checkbox3.$model" :true-value=YES :false-value=UN_YES
                                       @click.self="selectQuestion('cryptoBlock', 'checkbox3', YES, $event)"/>
                                <span class="checkbox_agree">{{ $t('customer.agree.yes') }}</span>
                            </label>
                        </div>
                        <div class="checkbox-custom">
                            <label class="label-checkbox" :class="cssLabelNo(cryptoBlock.checkbox3)">
                                <input class="checkboxone" type="checkbox" v-model="$v.cryptoBlock.checkbox3.$model" :true-value=NO :false-value=UN_NO
                                       @click.self="selectQuestion('cryptoBlock', 'checkbox3', NO, $event)"/>
                                <span class="checkbox_agree">{{ $t('customer.agree.no') }}</span>
                            </label>
                        </div>
                    </div>
                    <div class="error-messages-block-custom top--16px">
                        <error-messages-block :className="'error-messages-agreement ng-active'" :field="$v.cryptoBlock.checkbox3">
                            <template #required>{{ $t('accept.news.error.required') }}</template>
                        </error-messages-block>
                    </div>
                </div>
              </div>
            </div>
            <div class="section-box">
              <div class="box-item">
                <div class="left-part">
                  <div class="section-box-item">
                    <p>{{ $t('label.agreement.cryptoFX.confirmContent3') }}</p>
                  </div>
                </div>
                <div class="right-part background-block" :class="cssDivYes(cryptoBlock.checkbox4)" @click.self="toggleCheckbox($event)">
                    <div class="checkbox-block2 h-82px">
                        <div class="checkbox-custom vertical-line-crypto">
                            <label class="label-checkbox" :class="cssLabelYes(cryptoBlock.checkbox4)">
                                <input class="checkboxone" type="checkbox" v-model="$v.cryptoBlock.checkbox4.$model" :true-value=YES :false-value=UN_YES
                                       @click.self="selectQuestion('cryptoBlock', 'checkbox4', YES, $event)"/>
                                <span class="checkbox_agree">{{ $t('customer.agree.yes') }}</span>
                            </label>
                        </div>
                        <div class="checkbox-custom">
                            <label class="label-checkbox" :class="cssLabelNo(cryptoBlock.checkbox4)">
                                <input class="checkboxone" type="checkbox" v-model="$v.cryptoBlock.checkbox4.$model" :true-value=NO :false-value=UN_NO
                                       @click.self="selectQuestion('cryptoBlock', 'checkbox4', NO, $event)"/>
                                <span class="checkbox_agree">{{ $t('customer.agree.no') }}</span>
                            </label>
                        </div>
                    </div>
                    <div class="error-messages-block-custom top--16px">
                        <error-messages-block :className="'error-messages-agreement ng-active'" :field="$v.cryptoBlock.checkbox4">
                            <template #required>{{ $t('accept.news.error.required') }}</template>
                        </error-messages-block>
                    </div>
                </div>
              </div>
            </div>
            <div class="section-box">
              <div class="box-item">
                <div class="left-part">
                  <div class="section-box-item">
                    <p>{{ $t('label.agreement.cryptoFX.confirmContent4') }}</p>
                  </div>
                </div>
                <div class="right-part background-block" :class="cssDivYes(cryptoBlock.checkbox5)" @click.self="toggleCheckbox($event)">
                    <div class="checkbox-block2 h-82px">
                        <div class="checkbox-custom vertical-line-crypto">
                            <label class="label-checkbox" :class="cssLabelYes(cryptoBlock.checkbox5)">
                                <input class="checkboxone" type="checkbox" v-model="$v.cryptoBlock.checkbox5.$model" :true-value=YES :false-value=UN_YES
                                       @click.self="selectQuestion('cryptoBlock', 'checkbox5', YES, $event)"/>
                                <span class="checkbox_agree">{{ $t('customer.agree.yes') }}</span>
                            </label>
                        </div>
                        <div class="checkbox-custom">
                            <label class="label-checkbox" :class="cssLabelNo(cryptoBlock.checkbox5)">
                                <input class="checkboxone" type="checkbox" v-model="$v.cryptoBlock.checkbox5.$model" :true-value=NO :false-value=UN_NO
                                       @click.self="selectQuestion('cryptoBlock', 'checkbox5', NO, $event)"/>
                                <span class="checkbox_agree">{{ $t('customer.agree.no') }}</span>
                            </label>
                        </div>
                    </div>
                    <div class="error-messages-block-custom top--16px">
                        <error-messages-block :className="'error-messages-agreement ng-active'" :field="$v.cryptoBlock.checkbox5">
                            <template #required>{{ $t('accept.news.error.required') }}</template>
                        </error-messages-block>
                    </div>
                </div>
              </div>
            </div>
            <div class="section-box">
              <div class="box-item">
                <div class="left-part">
                  <div class="section-box-item">
                    <p>{{ $t('label.agreement.cryptoFX.confirmContent5') }}</p>
                  </div>
                </div>
                <div class="right-part background-block" :class="cssDivYes(cryptoBlock.checkbox6)" @click.self="toggleCheckbox($event)">
                    <div class="checkbox-block2 h-82px">
                        <div class="checkbox-custom vertical-line-crypto">
                            <label class="label-checkbox" :class="cssLabelYes(cryptoBlock.checkbox6)">
                                <input class="checkboxone" type="checkbox" v-model="$v.cryptoBlock.checkbox6.$model" :true-value=YES :false-value=UN_YES
                                       @click.self="selectQuestion('cryptoBlock', 'checkbox6', YES, $event)"/>
                                <span class="checkbox_agree">{{ $t('customer.agree.yes') }}</span>
                            </label>
                        </div>
                        <div class="checkbox-custom">
                            <label class="label-checkbox" :class="cssLabelNo(cryptoBlock.checkbox6)">
                                <input class="checkboxone" type="checkbox" v-model="$v.cryptoBlock.checkbox6.$model" :true-value=NO :false-value=UN_NO
                                       @click.self="selectQuestion('cryptoBlock', 'checkbox6', NO, $event)"/>
                                <span class="checkbox_agree">{{ $t('customer.agree.no') }}</span>
                            </label>
                        </div>
                    </div>
                    <div class="error-messages-block-custom top--16px">
                        <error-messages-block :className="'error-messages-agreement ng-active'" :field="$v.cryptoBlock.checkbox6">
                            <template #required>{{ $t('accept.news.error.required') }}</template>
                        </error-messages-block>
                    </div>
                </div>
              </div>
            </div>
            <div class="section-box">
              <div class="box-item">
                <div class="left-part">
                  <div class="section-box-item">
                    <p>{{ $t('label.agreement.cryptoFX.confirmContent6') }}</p>
                  </div>
                </div>
                <div class="right-part background-block" :class="cssDivYes(cryptoBlock.checkbox7)" @click.self="toggleCheckbox($event)">
                    <div class="checkbox-block2 h-82px">
                        <div class="checkbox-custom vertical-line-crypto">
                            <label class="label-checkbox" :class="cssLabelYes(cryptoBlock.checkbox7)">
                                <input class="checkboxone" type="checkbox" v-model="$v.cryptoBlock.checkbox7.$model" :true-value=YES :false-value=UN_YES
                                       @click.self="selectQuestion('cryptoBlock', 'checkbox7', YES, $event)"/>
                                <span class="checkbox_agree">{{ $t('customer.agree.yes') }}</span>
                            </label>
                        </div>
                        <div class="checkbox-custom">
                            <label class="label-checkbox" :class="cssLabelNo(cryptoBlock.checkbox7)">
                                <input class="checkboxone" type="checkbox" v-model="$v.cryptoBlock.checkbox7.$model" :true-value=NO :false-value=UN_NO
                                       @click.self="selectQuestion('cryptoBlock', 'checkbox7', NO, $event)"/>
                                <span class="checkbox_agree">{{ $t('customer.agree.no') }}</span>
                            </label>
                        </div>
                    </div>
                    <div class="error-messages-block-custom top--16px">
                        <error-messages-block :className="'error-messages-agreement ng-active'" :field="$v.cryptoBlock.checkbox7">
                            <template #required>{{ $t('accept.news.error.required') }}</template>
                        </error-messages-block>
                    </div>
                </div>
              </div>
            </div>
            <div class="section-box">
              <div class="box-item">
                <div class="left-part">
                  <div class="section-box-item">
                    <p>{{ $t('label.agreement.cryptoFX.confirmContent7') }}</p>
                  </div>
                </div>
                <div class="right-part background-block" :class="cssDivYes(cryptoBlock.checkbox8)" @click.self="toggleCheckbox($event)">
                    <div class="checkbox-block2 h-82px">
                        <div class="checkbox-custom vertical-line-crypto">
                            <label class="label-checkbox" :class="cssLabelYes(cryptoBlock.checkbox8)">
                                <input class="checkboxone" type="checkbox" v-model="$v.cryptoBlock.checkbox8.$model" :true-value=YES :false-value=UN_YES
                                       @click.self="selectQuestion('cryptoBlock', 'checkbox8', YES, $event)"/>
                                <span class="checkbox_agree">{{ $t('customer.agree.yes') }}</span>
                            </label>
                        </div>
                        <div class="checkbox-custom">
                            <label class="label-checkbox" :class="cssLabelNo(cryptoBlock.checkbox8)">
                                <input class="checkboxone" type="checkbox" v-model="$v.cryptoBlock.checkbox8.$model" :true-value=NO :false-value=UN_NO
                                       @click.self="selectQuestion('cryptoBlock', 'checkbox8', NO, $event)"/>
                                <span class="checkbox_agree">{{ $t('customer.agree.no') }}</span>
                            </label>
                        </div>
                    </div>
                    <div class="error-messages-block-custom top--16px">
                        <error-messages-block :className="'error-messages-agreement ng-active'" :field="$v.cryptoBlock.checkbox8">
                            <template #required>{{ $t('accept.news.error.required') }}</template>
                        </error-messages-block>
                    </div>
                </div>
              </div>
            </div>
            <div class="section-box">
              <div class="box-item">
                <div class="left-part">
                  <div class="section-box-item">
                    <p>{{ $t('label.agreement.cryptoFX.confirmContent8') }}</p>
                    <p>{{ $t('label.agreement.cryptoFX.confirmContent9') }}</p>
                    <p>{{ $t('label.agreement.cryptoFX.confirmContent10') }}</p>
                  </div>
                </div>
                <div class="right-part background-block" :class="cssDivYes(cryptoBlock.checkbox9)" @click.self="toggleCheckbox($event)">
                    <div class="checkbox-block2 h-132px">
                        <div class="checkbox-custom vertical-line-crypto">
                            <label class="label-checkbox" :class="cssLabelYes(cryptoBlock.checkbox9)">
                                <input class="checkboxone" type="checkbox" v-model="$v.cryptoBlock.checkbox9.$model" :true-value=YES :false-value=UN_YES
                                       @click.self="selectQuestion('cryptoBlock', 'checkbox9', YES, $event)"/>
                                <span class="checkbox_agree">{{ $t('customer.agree.yes') }}</span>
                            </label>
                        </div>
                        <div class="checkbox-custom">
                            <label class="label-checkbox" :class="cssLabelNo(cryptoBlock.checkbox9)">
                                <input class="checkboxone" type="checkbox" v-model="$v.cryptoBlock.checkbox9.$model" :true-value=NO :false-value=UN_NO
                                       @click.self="selectQuestion('cryptoBlock', 'checkbox9', NO, $event)"/>
                                <span class="checkbox_agree">{{ $t('customer.agree.no') }}</span>
                            </label>
                        </div>
                    </div>
                    <div class="error-messages-block-custom top--40px">
                        <error-messages-block :className="'error-messages-agreement ng-active'" :field="$v.cryptoBlock.checkbox9">
                            <template #required>{{ $t('accept.news.error.required') }}</template>
                        </error-messages-block>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

            <div class="section">
              <h2 class="section-title">{{ $t('label.agreement.confirmationOfRegistrationInformation') }}</h2>
              <div class="section-ct">
                <div class="section-box">
                  <div class="box-item">
                    <div class="left-part">
                      <div class="section-box-item">
                        <p>{{ $t('label.agreement.InformationContent1') }}</p>
                      </div>
                    </div>
                    <div class="right-part background-block" :class="cssDivYes(agreementBlock.checkboxLastAgreement)" @click.self="toggleCheckbox($event)">
                        <div>
                            <label class="label-checkbox" :class="cssLabelYes(agreementBlock.checkboxLastAgreement)">
                               <input class="checkboxone" type="checkbox" v-model="$v.agreementBlock.checkboxLastAgreement.$model" :true-value=YES :false-value=UN_YES
                                      @click.self="selectQuestion('agreementBlock', 'checkboxLastAgreement',YES, $event)"/>
                               <span class="checkbox_agree">{{ $t('customer.agree.yes') }}</span>
                            </label>
                        </div>
                        <div class="error-messages-block-custom error-messages-block-custom2 top--12px">
                            <error-messages-block :className="'error-messages-agreement ng-active left2'" :field="$v.agreementBlock.checkboxLastAgreement">
                                <template #required>{{ $t('accept.news.error.required') }}</template>
                            </error-messages-block>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="section">
              <div class="section-ct">
                <div class="section-box">
                  <div class="section-box-item">
                    <div class="row">
                      <div class="col-md-12">
                        <p>{{ $t('label.agreement.agreementNote1') }}<br>{{ $t('label.agreement.agreementNote2') }}<br>{{ this.telephone }}</p>
                      </div>
                    </div>
                    <div class="section-action text-center">
                      <button id="btnsave" type="submit" class="btn btn-lg allanswered" :class="this.disabledBtn ? 'btn-success' : 'btn-not-allowed'" @click="saveAgreement()">{{$t('customer.agree.saveAgree')}}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
/**
 * @author HungNS
 */
import $ from "jquery";
import {createNamespacedHelpers} from "vuex";
import _ from "lodash";
import * as NEWS_TYPE from "@/store/modules/news/type";
import IConstants from "@/common/constants/IConstants";
import postDocTemplateMixin from "@/common/mixins/postDocTemplate";

const {mapState: mapNewsState, mapActions: mapNewsActions} = createNamespacedHelpers("news");

export default {
    mixins: [postDocTemplateMixin],
    data() {
        return {
            minStHome: IConstants.WEB_LINK.MIN_ST_HOME,
            allAnswered: false,
            cryptoLogo: IConstants.LINK_ASSETS.CRYPTO_LOGO,
            errorMessage: null,
            fxBlock: {
                checkbox1: null,
                checkbox2: null,
                checkbox3: null,
            },
            boBlock: {
              checkbox1: null,
              checkbox2: null,
              checkbox3: null,
              checkbox4: null,
              checkbox5: null,
              checkbox6: null,
              checkbox7: null,
              checkbox8: null,
              checkbox9: null,
              checkbox10: null
            },
            cryptoBlock: {
              checkbox1: null,
              checkbox2: null,
              checkbox3: null,
              checkbox4: null,
              checkbox5: null,
              checkbox6: null,
              checkbox7: null,
              checkbox8: null,
              checkbox9: null
            },
            agreementBlock: {
                checkboxLastAgreement: null
            },
            submit: {
                fxBlock: {},
                boBlock: {},
                cryptoBlock: {},
                agreementBlock: {},
            },
            YES: 'yes',
            UN_YES: 'un_yes',
            NO: 'no',
            UN_NO: 'un_no'
        }
    },
    validations() {
        return {
            fxBlock: {
                checkbox1: {
                    required: () => {
                        return this.showErrorMsg(this.fxBlock.checkbox1, this.submit.fxBlock.checkbox1);
                    },
                },
                checkbox2: {
                    required: () => {
                        return this.showErrorMsg(this.fxBlock.checkbox2, this.submit.fxBlock.checkbox2);
                    },
                },
                checkbox3: {
                    required: () => {
                        return this.showErrorMsg(this.fxBlock.checkbox3, this.submit.fxBlock.checkbox3);
                    },
                },
            },
            boBlock: {
                checkbox1: {
                    required: () => {
                        return this.showErrorMsg(this.boBlock.checkbox1, this.submit.boBlock.checkbox1);
                    },
                },
                checkbox2: {
                    required: () => {
                        return this.showErrorMsg(this.boBlock.checkbox2, this.submit.boBlock.checkbox2);
                    },
                },
                checkbox3: {
                    required: () => {
                        return this.showErrorMsg(this.boBlock.checkbox3, this.submit.boBlock.checkbox3);
                    },
                },
                checkbox4: {
                    required: () => {
                        return this.showErrorMsg(this.boBlock.checkbox4, this.submit.boBlock.checkbox4);
                    },
                },
                checkbox5: {
                    required: () => {
                        return this.showErrorMsg(this.boBlock.checkbox5, this.submit.boBlock.checkbox5);
                    },
                },
                checkbox6: {
                    required: () => {
                        return this.showErrorMsg(this.boBlock.checkbox6, this.submit.boBlock.checkbox6);
                    },
                },
                checkbox7: {
                    required: () => {
                        return this.showErrorMsg(this.boBlock.checkbox7, this.submit.boBlock.checkbox7);
                    },
                },
                checkbox8: {
                    required: () => {
                        return this.showErrorMsg(this.boBlock.checkbox8, this.submit.boBlock.checkbox8);
                    },
                },
                checkbox9: {
                    required: () => {
                        return this.showErrorMsg(this.boBlock.checkbox9, this.submit.boBlock.checkbox9);
                    },
                },
                checkbox10: {
                    required: () => {
                        return this.showErrorMsg(this.boBlock.checkbox10, this.submit.boBlock.checkbox10);
                    },
                }
            },
            cryptoBlock: {
                checkbox1: {
                    required: () => {
                        return this.showErrorMsg(this.cryptoBlock.checkbox1, this.submit.cryptoBlock.checkbox1);
                    },
                },
                checkbox2: {
                    required: () => {
                        return this.showErrorMsg(this.cryptoBlock.checkbox2, this.submit.cryptoBlock.checkbox2);
                    },
                },
                checkbox3: {
                    required: () => {
                        return this.showErrorMsg(this.cryptoBlock.checkbox3, this.submit.cryptoBlock.checkbox3);
                    },
                },
                checkbox4: {
                    required: () => {
                        return this.showErrorMsg(this.cryptoBlock.checkbox4, this.submit.cryptoBlock.checkbox4);
                    },
                },
                checkbox5: {
                    required: () => {
                        return this.showErrorMsg(this.cryptoBlock.checkbox5, this.submit.cryptoBlock.checkbox5);
                    },
                },
                checkbox6: {
                    required: () => {
                        return this.showErrorMsg(this.cryptoBlock.checkbox6, this.submit.cryptoBlock.checkbox6);
                    },
                },
                checkbox7: {
                    required: () => {
                        return this.showErrorMsg(this.cryptoBlock.checkbox7, this.submit.cryptoBlock.checkbox7);
                    },
                },
                checkbox8: {
                    required: () => {
                        return this.showErrorMsg(this.cryptoBlock.checkbox8, this.submit.cryptoBlock.checkbox8);
                    },
                },
                checkbox9: {
                    required: () => {
                        return this.showErrorMsg(this.cryptoBlock.checkbox9, this.submit.cryptoBlock.checkbox9);
                    },
                }
            },
            agreementBlock: {
                checkboxLastAgreement: {
                    required: () => {
                        return this.showErrorMsg(this.agreementBlock.checkboxLastAgreement, this.submit.agreementBlock.checkboxLastAgreement);
                    },
                },
            }
        };
    },
    computed: {
        ...mapNewsState({
            newsInfo: state => state
        }),
        disabledBtn() {
            return this.allAnswered;
        }
    },
    methods: {
        ...mapNewsActions([NEWS_TYPE.SET_RE_AGREEMENT_FLG]),
        selectQuestion(blockName, checkboxName, type, e) {
            if (this.submit[blockName] && this.submit[blockName][checkboxName]) this.submit[blockName][checkboxName] = false;
            let checkedFlag = e.target.checked;
            if (this.checkedYes(type)) this[blockName][checkboxName] = checkedFlag ? this.YES : this.UN_YES;
            else this[blockName][checkboxName] = checkedFlag ? this.NO : this.UN_NO;

            let hasAgreeFx = true;
            let hasAgreeBo = true;
            let hasAgreeCrypto = true;
            let hasAgreeLastAgreement = false;

            if (this.newsInfo.hasAgreementFxBlock) hasAgreeFx = Object.values(this.fxBlock).every(i => this.checkedYes(i));
            if (this.newsInfo.hasAgreementBoBlock) hasAgreeBo = Object.values(this.boBlock).every(i => this.checkedYes(i));
            if (this.newsInfo.hasAgreementCryptoFxBlock) hasAgreeCrypto = Object.values(this.cryptoBlock).every(i => this.checkedYes(i));
            hasAgreeLastAgreement = this.checkedYes(this.agreementBlock.checkboxLastAgreement);
          
            this.allAnswered = hasAgreeFx && hasAgreeBo && hasAgreeCrypto && hasAgreeLastAgreement;
        },
        toggleCheckbox(event) {
            const clickedDiv = event.currentTarget;
            const checkboxInput = clickedDiv.querySelector('.checkboxone');
            checkboxInput.click();
        },
        showLendModal() {
            this.$modal.showAgreementNewsModal({
                type: this.IConstants.AGREEMENT_NEWS_MODAL_TYPE.LEND,
            });
        },
        showPepModal() {
            this.$modal.showAgreementNewsModal({
                type: this.IConstants.AGREEMENT_NEWS_MODAL_TYPE.PEP,
            });
        },
        async saveAgreement() {
            this.enforceValidateForSubmit();
            if (this.allAnswered) {
                let params = new FormData();
                params.append("messageId", this.newsInfo.reAgreeMessageId);
                let response = await this.$service.getService("news").saveAgreeNews(params);
                if (response && response.data) {
                    if (response.data.errorMessage) {
                        this.errorMessage = response.data.errorMessage;
                        return;
                    }
                    this[NEWS_TYPE.SET_RE_AGREEMENT_FLG](false);
                    this.$root.$emit(this.IConstants.EVENT_NAME.ON_CONFIRM_AGREEMENT_WEBKIT);
                    if (this.newsInfo.listForceNewsInfo && this.newsInfo.listForceNewsInfo.length > 0) {
                        this.$router.push({name: 'forceNews'});
                    } else {
                        this.$router.push({name: 'home'});
                    }
                }
            } else {
                this.gotoFistInvalidElement();
            }
        },
        gotoFistInvalidElement() {
            // Trigger validate form
            this.$v.$touch();
            // Scroll to first error field
            setTimeout(() => {
                const firstError = $('.error-messages-agreement.ng-active')[0];

                if (firstError != null) {
                    $('html, body').animate(
                        {
                            scrollTop: $(firstError).offset().top - 200,
                        },
                        1000
                    );
                }
            }, 100);
        },
        checkedYes(field) {
            return field === this.YES;
        },
        checkedNo(field) {
            return field === this.NO;
        },
        cssDivYes(field) {
            return this.checkedYes(field) ? 'accepted-background' : '';
        },
        cssLabelYes(field) {
            return this.checkedYes(field) ? 'box-checked' : '';
        },
        cssLabelNo(field) {
            return this.checkedNo(field) ? 'box-checked' : '';
        },
        showErrorMsg(field, submitFlg) {
            return !(field === this.NO || field === this.UN_YES || (submitFlg === true && field !== this.YES));
        },
        enforceValidateForSubmit() {
            this.submit.fxBlock = _.mapValues(this.fxBlock, () => true);
            this.submit.boBlock = _.mapValues(this.boBlock, () => true);
            this.submit.cryptoBlock = _.mapValues(this.cryptoBlock, () => true);
            this.submit.agreementBlock = _.mapValues(this.agreementBlock, () => true);
        }
    },
};
</script>
<style scoped>

.btn-default {
    margin-left: 4px;
}

.btn-warning {
    color: white !important;
}

.btn-not-allowed {
    color: #16151554;
    cursor: not-allowed!important;
}

.checkbox-custom {
    width: 100%;
}

.checkbox-custom label {
    padding-left: 14px;
}

.label-checkbox {
    height: 100% !important;
}

.checkbox-block {
    display: flex;
    position: relative;
    height: 250px;
}

.checkbox-block2 {
    display: flex;
}

.right-part.background-block {
    position: relative;
    padding-bottom: 1px;
}

.error-messages-block-custom {
    position: relative;
}

.container-agreement {
    margin-right: auto;
    margin-left: auto;
}

@media (min-width: 1200px) {
    .container-agreement {
        width: 1140px;
    }
}

.h-82px {
  height: 82px;
}

.h-100px {
  height: 100px;
}

.h-132px {
  height: 132px;
}

.top--12px {
  top: -12px;
}

.top--16px {
  top: -16px;
}

.top--24px {
  top: -24px;
}

.top--40px {
  top: -40px;
}

.top--126px {
  top: -126px;
}

.checkbox_agree {
    white-space: nowrap;
}
</style>
